import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { nanoid } from 'nanoid';


export default /*@__PURE__*/_defineComponent({
  __name: 'Intendation',
  props: {
    level: {}
  },
  setup(__props: any) {



const hash = nanoid();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (__props.level)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.level-1, (n) => {
          return (_openBlock(), _createBlock(_component_v_icon, {
            size: "small",
            class: "indent dot",
            key: _unref(hash) + n
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-circle-small", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode(_component_v_icon, {
          size: "small",
          class: "indent arrow"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-arrow-right-bottom", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}
}

})